import { render, staticRenderFns } from "./AddCostTemplateModal.vue?vue&type=template&id=716ff424&"
import script from "./AddCostTemplateModal.vue?vue&type=script&lang=js&"
export * from "./AddCostTemplateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports